import { MOIS_LABELS } from '../types';

export interface ImpactPortee {
  /** Mois (1..12) dont la projection sera remplacée par la nouvelle valeur. */
  aRemplacer: number[];
  /** Mois portant un définitif ou un consolidé : laissés intacts. */
  proteges: number[];
}

export const IMPACT_VIDE: ImpactPortee = { aRemplacer: [], proteges: [] };

/**
 * Événements ultérieurs masquant une édition « dès M » : un événement dont le
 * mois d'effet M2 > M reprend la main dès M2 — le mois d'effet prime, la date
 * de saisie ne départage que les événements du même mois. « Sans fin » veut
 * donc dire « jusqu'au prochain événement », pas « jusqu'en décembre » : pour
 * tenir la promesse du libellé, l'édition rapide réécrit sa valeur sur chaque
 * mois couvert par la portée où une projection prenait effet. Les définitifs
 * (réels facturés, décisions) ne sont jamais écrasés.
 */
export function impactPortee(
  tagsChangement: Array<string | null | undefined>, // index 0 = janvier
  moisDebut: number,
  moisFin: number, // 12 pour « sans fin »
): ImpactPortee {
  const aRemplacer: number[] = [];
  const proteges: number[] = [];
  for (let m = moisDebut + 1; m <= moisFin; m++) {
    const tag = tagsChangement[m - 1];
    if (!tag) continue;
    (tag === 'projete' ? aRemplacer : proteges).push(m);
  }
  return { aRemplacer, proteges };
}

export function fusionnerImpacts(...impacts: ImpactPortee[]): ImpactPortee {
  const uniq = (xs: number[]) => [...new Set(xs)].sort((a, b) => a - b);
  return {
    aRemplacer: uniq(impacts.flatMap((i) => i.aRemplacer)),
    proteges: uniq(impacts.flatMap((i) => i.proteges)),
  };
}

export function listerMois(mois: number[]): string {
  return mois.map((m) => MOIS_LABELS[m - 1].toLowerCase()).join(', ');
}
